import { render, staticRenderFns } from "./Locality.vue?vue&type=template&id=3451c18b&scoped=true"
import script from "./Locality.vue?vue&type=script&lang=js"
export * from "./Locality.vue?vue&type=script&lang=js"
import style0 from "./Locality.vue?vue&type=style&index=0&id=3451c18b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3451c18b",
  null
  
)

export default component.exports